import type { Skill } from 'bundles/browse-common/legacy/components/Domain/types/Skill';

import _t from 'i18n!nls/browse';

// optimized version, we're only using 12 max so we're going to only have 12 items per subdomain

const getSubDomainSkillsData = (): Array<Skill> => {
  return [
    {
      domainId: 'business',
      subDomainId: 'business-essentials',
      skillId: 'analytics',
      skillName: _t('analytics'),
      numberOfTaggedCourses: 37,
      skillSearchUrl: '/courses?query=analytics',
    },
    {
      domainId: 'business',
      subDomainId: 'business-essentials',
      skillId: 'presentation',
      skillName: _t('presentation'),
      numberOfTaggedCourses: 33,
      skillSearchUrl: '/courses?query=presentation',
    },
    {
      domainId: 'business',
      subDomainId: 'business-essentials',
      skillId: 'modeling',
      skillName: _t('modeling'),
      numberOfTaggedCourses: 29,
      skillSearchUrl: '/courses?query=modelling',
    },
    {
      domainId: 'business',
      subDomainId: 'business-essentials',
      skillId: 'business-analytics',
      skillName: _t('business analytics'),
      numberOfTaggedCourses: 27,
      skillSearchUrl: '/courses?query=business%20analytics',
    },
    {
      domainId: 'business',
      subDomainId: 'business-essentials',
      skillId: 'language',
      skillName: _t('language'),
      numberOfTaggedCourses: 26,
      skillSearchUrl: '/courses?query=language',
    },
    {
      domainId: 'business',
      subDomainId: 'business-essentials',
      skillId: 'microsoft-excel',
      skillName: _t('microsoft excel'),
      numberOfTaggedCourses: 26,
      skillSearchUrl: '/courses?query=microsoft%20excel',
    },
    {
      domainId: 'business',
      subDomainId: 'business-essentials',
      skillId: 'writing',
      skillName: _t('writing'),
      numberOfTaggedCourses: 26,
      skillSearchUrl: '/courses?query=writing',
    },
    {
      domainId: 'business',
      subDomainId: 'business-essentials',
      skillId: 'speech',
      skillName: _t('speech'),
      numberOfTaggedCourses: 18,
      skillSearchUrl: '/courses?query=speech',
    },
    {
      domainId: 'business',
      subDomainId: 'business-essentials',
      skillId: 'plan',
      skillName: _t('plan'),
      numberOfTaggedCourses: 17,
      skillSearchUrl: '/courses?query=planning',
    },
    {
      domainId: 'business',
      subDomainId: 'business-essentials',
      skillId: 'business-communication',
      skillName: _t('business communication'),
      numberOfTaggedCourses: 16,
      skillSearchUrl: '/courses?query=business%20communication',
    },
    {
      domainId: 'business',
      subDomainId: 'business-essentials',
      skillId: 'decision-making',
      skillName: _t('decision-making'),
      numberOfTaggedCourses: 16,
      skillSearchUrl: '/courses?query=decision%20making',
    },
    {
      domainId: 'business',
      subDomainId: 'business-essentials',
      skillId: 'leadership',
      skillName: _t('leadership'),
      numberOfTaggedCourses: 15,
      skillSearchUrl: '/courses?query=leadership',
    },
    {
      domainId: 'business',
      subDomainId: 'business-strategy',
      skillId: 'modeling',
      skillName: _t('modeling'),
      numberOfTaggedCourses: 25,
      skillSearchUrl: '/courses?query=modelling',
    },
    {
      domainId: 'business',
      subDomainId: 'business-strategy',
      skillId: 'market-economics',
      skillName: _t('market (economics)'),
      numberOfTaggedCourses: 21,
      skillSearchUrl: '/courses?query=financial%20market',
    },
    {
      domainId: 'business',
      subDomainId: 'business-strategy',
      skillId: 'plan',
      skillName: _t('plan'),
      numberOfTaggedCourses: 19,
      skillSearchUrl: '/courses?query=planning',
    },
    {
      domainId: 'business',
      subDomainId: 'business-strategy',
      skillId: 'planning',
      skillName: _t('Planning'),
      numberOfTaggedCourses: 16,
      skillSearchUrl: '/courses?query=Planning',
    },
    {
      domainId: 'business',
      subDomainId: 'business-strategy',
      skillId: 'strategic-management',
      skillName: _t('strategic management'),
      numberOfTaggedCourses: 16,
      skillSearchUrl: '/courses?query=strategic%20management',
    },
    {
      domainId: 'business',
      subDomainId: 'business-strategy',
      skillId: 'business-model',
      skillName: _t('business model'),
      numberOfTaggedCourses: 13,
      skillSearchUrl: '/courses?query=business%20model',
    },
    {
      domainId: 'business',
      subDomainId: 'business-strategy',
      skillId: 'operations-management',
      skillName: _t('operations management'),
      numberOfTaggedCourses: 13,
      skillSearchUrl: '/courses?query=operations%20management',
    },
    {
      domainId: 'business',
      subDomainId: 'business-strategy',
      skillId: 'analytics',
      skillName: _t('analytics'),
      numberOfTaggedCourses: 12,
      skillSearchUrl: '/courses?query=analytics',
    },
    {
      domainId: 'business',
      subDomainId: 'business-strategy',
      skillId: 'evaluation',
      skillName: _t('evaluation'),
      numberOfTaggedCourses: 12,
      skillSearchUrl: '/courses?query=valuation',
    },
    {
      domainId: 'business',
      subDomainId: 'business-strategy',
      skillId: 'project-management',
      skillName: _t('project management'),
      numberOfTaggedCourses: 11,
      skillSearchUrl: '/courses?query=project%20management',
    },
    {
      domainId: 'business',
      subDomainId: 'business-strategy',
      skillId: 'supply-chain',
      skillName: _t('supply chain'),
      numberOfTaggedCourses: 10,
      skillSearchUrl: '/courses?query=supply%20chain',
    },
    {
      domainId: 'business',
      subDomainId: 'business-strategy',
      skillId: 'decision-making',
      skillName: _t('decision-making'),
      numberOfTaggedCourses: 9,
      skillSearchUrl: '/courses?query=decision%20making',
    },
    {
      domainId: 'business',
      subDomainId: 'entrepreneurship',
      skillId: 'innovation',
      skillName: _t('innovation'),
      numberOfTaggedCourses: 38,
      skillSearchUrl: '/courses?query=innovation',
    },
    {
      domainId: 'business',
      subDomainId: 'entrepreneurship',
      skillId: 'modeling',
      skillName: _t('modeling'),
      numberOfTaggedCourses: 25,
      skillSearchUrl: '/courses?query=modelling',
    },
    {
      domainId: 'business',
      subDomainId: 'entrepreneurship',
      skillId: 'business-model',
      skillName: _t('business model'),
      numberOfTaggedCourses: 18,
      skillSearchUrl: '/courses?query=business%20model',
    },
    {
      domainId: 'business',
      subDomainId: 'entrepreneurship',
      skillId: 'plan',
      skillName: _t('plan'),
      numberOfTaggedCourses: 16,
      skillSearchUrl: '/courses?query=planning',
    },
    {
      domainId: 'business',
      subDomainId: 'entrepreneurship',
      skillId: 'investment',
      skillName: _t('investment'),
      numberOfTaggedCourses: 15,
      skillSearchUrl: '/courses?query=investment',
    },
    {
      domainId: 'business',
      subDomainId: 'entrepreneurship',
      skillId: 'market-economics',
      skillName: _t('market (economics)'),
      numberOfTaggedCourses: 15,
      skillSearchUrl: '/courses?query=financial%20market',
    },
    {
      domainId: 'business',
      subDomainId: 'entrepreneurship',
      skillId: 'product',
      skillName: _t('product'),
      numberOfTaggedCourses: 12,
      skillSearchUrl: '/courses?query=product',
    },
    {
      domainId: 'business',
      subDomainId: 'entrepreneurship',
      skillId: 'planning',
      skillName: _t('Planning'),
      numberOfTaggedCourses: 11,
      skillSearchUrl: '/courses?query=Planning',
    },
    {
      domainId: 'business',
      subDomainId: 'entrepreneurship',
      skillId: 'social-entrepreneurship',
      skillName: _t('social entrepreneurship'),
      numberOfTaggedCourses: 10,
      skillSearchUrl: '/courses?query=social%20entrepreneurship',
    },
    {
      domainId: 'business',
      subDomainId: 'entrepreneurship',
      skillId: 'strategic-management',
      skillName: _t('strategic management'),
      numberOfTaggedCourses: 10,
      skillSearchUrl: '/courses?query=strategic%20management',
    },
    {
      domainId: 'business',
      subDomainId: 'entrepreneurship',
      skillId: 'business-plan',
      skillName: _t('business plan'),
      numberOfTaggedCourses: 9,
      skillSearchUrl: '/courses?query=business%20plan',
    },
    {
      domainId: 'business',
      subDomainId: 'entrepreneurship',
      skillId: 'business-strategy',
      skillName: _t('Business Strategy'),
      numberOfTaggedCourses: 6,
      skillSearchUrl: '/courses?query=Business%20Strategy',
    },
    {
      domainId: 'business',
      subDomainId: 'finance',
      skillId: 'investment',
      skillName: _t('investment'),
      numberOfTaggedCourses: 23,
      skillSearchUrl: '/courses?query=investment',
    },
    {
      domainId: 'business',
      subDomainId: 'finance',
      skillId: 'market-economics',
      skillName: _t('market (economics)'),
      numberOfTaggedCourses: 20,
      skillSearchUrl: '/courses?query=financial%20market',
    },
    {
      domainId: 'business',
      subDomainId: 'finance',
      skillId: 'stock',
      skillName: _t('stock'),
      numberOfTaggedCourses: 18,
      skillSearchUrl: '/courses?query=stock%20market',
    },
    {
      domainId: 'business',
      subDomainId: 'finance',
      skillId: 'financial-statement',
      skillName: _t('financial statement'),
      numberOfTaggedCourses: 14,
      skillSearchUrl: '/courses?query=financial%20statements',
    },
    {
      domainId: 'business',
      subDomainId: 'finance',
      skillId: 'financial-accounting',
      skillName: _t('financial accounting'),
      numberOfTaggedCourses: 13,
      skillSearchUrl: '/courses?query=financial%20accounting',
    },
    {
      domainId: 'business',
      subDomainId: 'finance',
      skillId: 'modeling',
      skillName: _t('modeling'),
      numberOfTaggedCourses: 13,
      skillSearchUrl: '/courses?query=modelling',
    },
    {
      domainId: 'business',
      subDomainId: 'finance',
      skillId: 'corporate-finance',
      skillName: _t('corporate finance'),
      numberOfTaggedCourses: 11,
      skillSearchUrl: '/courses?query=corporate%20finance',
    },
    {
      domainId: 'business',
      subDomainId: 'finance',
      skillId: 'financial-analysis',
      skillName: _t('financial analysis'),
      numberOfTaggedCourses: 11,
      skillSearchUrl: '/courses?query=financial%20analysis',
    },
    {
      domainId: 'business',
      subDomainId: 'finance',
      skillId: 'trading',
      skillName: _t('trading'),
      numberOfTaggedCourses: 11,
      skillSearchUrl: '/courses?query=trading',
    },
    {
      domainId: 'business',
      subDomainId: 'finance',
      skillId: 'evaluation',
      skillName: _t('evaluation'),
      numberOfTaggedCourses: 10,
      skillSearchUrl: '/courses?query=valuation',
    },
    {
      domainId: 'business',
      subDomainId: 'finance',
      skillId: 'financial-markets',
      skillName: _t('financial markets'),
      numberOfTaggedCourses: 10,
      skillSearchUrl: '/courses?query=financial%20markets',
    },
    {
      domainId: 'business',
      subDomainId: 'finance',
      skillId: 'pricing',
      skillName: _t('pricing'),
      numberOfTaggedCourses: 10,
      skillSearchUrl: '/courses?query=pricing',
    },
    {
      domainId: 'business',
      subDomainId: 'leadership-and-management',
      skillId: 'leadership',
      skillName: _t('leadership'),
      numberOfTaggedCourses: 53,
      skillSearchUrl: '/courses?query=leadership',
    },
    {
      domainId: 'business',
      subDomainId: 'leadership-and-management',
      skillId: 'project-management',
      skillName: _t('project management'),
      numberOfTaggedCourses: 30,
      skillSearchUrl: '/courses?query=project%20management',
    },
    {
      domainId: 'business',
      subDomainId: 'leadership-and-management',
      skillId: 'plan',
      skillName: _t('plan'),
      numberOfTaggedCourses: 25,
      skillSearchUrl: '/courses?query=planning',
    },
    {
      domainId: 'business',
      subDomainId: 'leadership-and-management',
      skillId: 'planning',
      skillName: _t('Planning'),
      numberOfTaggedCourses: 24,
      skillSearchUrl: '/courses?query=Planning',
    },
    {
      domainId: 'business',
      subDomainId: 'leadership-and-management',
      skillId: 'modeling',
      skillName: _t('modeling'),
      numberOfTaggedCourses: 17,
      skillSearchUrl: '/courses?query=modelling',
    },
    {
      domainId: 'business',
      subDomainId: 'leadership-and-management',
      skillId: 'analytics',
      skillName: _t('analytics'),
      numberOfTaggedCourses: 16,
      skillSearchUrl: '/courses?query=analytics',
    },
    {
      domainId: 'business',
      subDomainId: 'leadership-and-management',
      skillId: 'human-resources',
      skillName: _t('human resources'),
      numberOfTaggedCourses: 16,
      skillSearchUrl: '/courses?query=human%20resources',
    },
    {
      domainId: 'business',
      subDomainId: 'leadership-and-management',
      skillId: 'decision-making',
      skillName: _t('decision-making'),
      numberOfTaggedCourses: 15,
      skillSearchUrl: '/courses?query=decision%20making',
    },
    {
      domainId: 'business',
      subDomainId: 'leadership-and-management',
      skillId: 'change-management',
      skillName: _t('change management'),
      numberOfTaggedCourses: 14,
      skillSearchUrl: '/courses?query=change%20management',
    },
    {
      domainId: 'business',
      subDomainId: 'leadership-and-management',
      skillId: 'innovation',
      skillName: _t('innovation'),
      numberOfTaggedCourses: 14,
      skillSearchUrl: '/courses?query=innovation',
    },
    {
      domainId: 'business',
      subDomainId: 'leadership-and-management',
      skillId: 'negotiation',
      skillName: _t('negotiation'),
      numberOfTaggedCourses: 14,
      skillSearchUrl: '/courses?query=negotiation',
    },
    {
      domainId: 'business',
      subDomainId: 'leadership-and-management',
      skillId: 'human-resource-management',
      skillName: _t('human resource management'),
      numberOfTaggedCourses: 13,
      skillSearchUrl: '/courses?query=human%20resource%20management',
    },
    {
      domainId: 'business',
      subDomainId: 'marketing',
      skillId: 'market-economics',
      skillName: _t('market (economics)'),
      numberOfTaggedCourses: 28,
      skillSearchUrl: '/courses?query=financial%20market',
    },
    {
      domainId: 'business',
      subDomainId: 'marketing',
      skillId: 'social-media',
      skillName: _t('social media'),
      numberOfTaggedCourses: 15,
      skillSearchUrl: '/courses?query=social%20media',
    },
    {
      domainId: 'business',
      subDomainId: 'marketing',
      skillId: 'marketing-strategy',
      skillName: _t('marketing strategy'),
      numberOfTaggedCourses: 14,
      skillSearchUrl: '/courses?query=marketing%20strategy',
    },
    {
      domainId: 'business',
      subDomainId: 'marketing',
      skillId: 'analytics',
      skillName: _t('analytics'),
      numberOfTaggedCourses: 13,
      skillSearchUrl: '/courses?query=analytics',
    },
    {
      domainId: 'business',
      subDomainId: 'marketing',
      skillId: 'brand',
      skillName: _t('brand'),
      numberOfTaggedCourses: 13,
      skillSearchUrl: '/courses?query=brand',
    },
    {
      domainId: 'business',
      subDomainId: 'marketing',
      skillId: 'digital-marketing',
      skillName: _t('digital marketing'),
      numberOfTaggedCourses: 13,
      skillSearchUrl: '/courses?query=digital%20marketing',
    },
    {
      domainId: 'business',
      subDomainId: 'marketing',
      skillId: 'marketing-analytics',
      skillName: _t('marketing analytics'),
      numberOfTaggedCourses: 11,
      skillSearchUrl: '/courses?query=marketing%20analytics',
    },
    {
      domainId: 'business',
      subDomainId: 'marketing',
      skillId: 'plan',
      skillName: _t('plan'),
      numberOfTaggedCourses: 11,
      skillSearchUrl: '/courses?query=planning',
    },
    {
      domainId: 'business',
      subDomainId: 'marketing',
      skillId: 'advertising',
      skillName: _t('advertising'),
      numberOfTaggedCourses: 9,
      skillSearchUrl: '/courses?query=advertising',
    },
    {
      domainId: 'business',
      subDomainId: 'marketing',
      skillId: 'modeling',
      skillName: _t('modeling'),
      numberOfTaggedCourses: 9,
      skillSearchUrl: '/courses?query=modelling',
    },
    {
      domainId: 'business',
      subDomainId: 'marketing',
      skillId: 'social-media-marketing',
      skillName: _t('social media marketing'),
      numberOfTaggedCourses: 9,
      skillSearchUrl: '/courses?query=social%20media marketing',
    },
    {
      domainId: 'business',
      subDomainId: 'marketing',
      skillId: 'brand-management',
      skillName: _t('brand management'),
      numberOfTaggedCourses: 7,
      skillSearchUrl: '/courses?query=brand%20management',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'algorithms',
      skillId: 'graphs',
      skillName: _t('graphs'),
      numberOfTaggedCourses: 22,
      skillSearchUrl: '/courses?query=graph',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'algorithms',
      skillId: 'mathematical-optimization',
      skillName: _t('mathematical optimization'),
      numberOfTaggedCourses: 21,
      skillSearchUrl: '/courses?query=mathematical%20optimization',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'algorithms',
      skillId: 'computer-program',
      skillName: _t('computer program'),
      numberOfTaggedCourses: 20,
      skillSearchUrl: '/courses?query=computer%20programs',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'algorithms',
      skillId: 'data-structure',
      skillName: _t('data structure'),
      numberOfTaggedCourses: 19,
      skillSearchUrl: '/courses?query=data%20structure',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'algorithms',
      skillId: 'problem-solving',
      skillName: _t('problem solving'),
      numberOfTaggedCourses: 19,
      skillSearchUrl: '/courses?query=problem%20solving',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'algorithms',
      skillId: 'algebra',
      skillName: _t('algebra'),
      numberOfTaggedCourses: 12,
      skillSearchUrl: '/courses?query=algebra',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'algorithms',
      skillId: 'computer-vision',
      skillName: _t('computer vision'),
      numberOfTaggedCourses: 10,
      skillSearchUrl: '/courses?query=computer%20vision',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'algorithms',
      skillId: 'discrete-mathematics',
      skillName: _t('discrete mathematics'),
      numberOfTaggedCourses: 10,
      skillSearchUrl: '/courses?query=discrete%20mathematics',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'algorithms',
      skillId: 'graph-theory',
      skillName: _t('graph theory'),
      numberOfTaggedCourses: 10,
      skillSearchUrl: '/courses?query=graph%20theory',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'algorithms',
      skillId: 'image-processing',
      skillName: _t('image processing'),
      numberOfTaggedCourses: 10,
      skillSearchUrl: '/courses?query=image%20processing',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'algorithms',
      skillId: 'linear-algebra',
      skillName: _t('linear algebra'),
      numberOfTaggedCourses: 10,
      skillSearchUrl: '/courses?query=linear%20algebra',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'algorithms',
      skillId: 'reinforcement-learning',
      skillName: _t('reinforcement learning'),
      numberOfTaggedCourses: 10,
      skillSearchUrl: '/courses?query=reinforcement%20learning',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'computer-security-and-networks',
      skillId: 'computer-security',
      skillName: _t('cybersecurity'),
      numberOfTaggedCourses: 33,
      skillSearchUrl: '/courses?query=cybersecurity',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'computer-security-and-networks',
      skillId: 'google',
      skillName: _t('google'),
      numberOfTaggedCourses: 25,
      skillSearchUrl: '/courses?query=google',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'computer-security-and-networks',
      skillId: 'google-cloud-platform',
      skillName: _t('google cloud platform'),
      numberOfTaggedCourses: 17,
      skillSearchUrl: '/courses?query=google%20cloud%20platform',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'computer-security-and-networks',
      skillId: 'internet',
      skillName: _t('internet'),
      numberOfTaggedCourses: 17,
      skillSearchUrl: '/courses?query=internet',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'computer-security-and-networks',
      skillId: 'cryptography',
      skillName: _t('cryptography'),
      numberOfTaggedCourses: 16,
      skillSearchUrl: '/courses?query=cryptography',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'computer-security-and-networks',
      skillId: 'network-security',
      skillName: _t('network security'),
      numberOfTaggedCourses: 16,
      skillSearchUrl: '/courses?query=network%20security',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'computer-security-and-networks',
      skillId: 'linux',
      skillName: _t('linux'),
      numberOfTaggedCourses: 12,
      skillSearchUrl: '/courses?query=linux',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'computer-security-and-networks',
      skillId: 'software-testing',
      skillName: _t('software testing'),
      numberOfTaggedCourses: 12,
      skillSearchUrl: '/courses?query=software%20testing',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'computer-security-and-networks',
      skillId: 'information-security',
      skillName: _t('information security'),
      numberOfTaggedCourses: 10,
      skillSearchUrl: '/courses?query=information%20security',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'computer-security-and-networks',
      skillId: 'application-programming-interfaces',
      skillName: _t('application programming interfaces'),
      numberOfTaggedCourses: 8,
      skillSearchUrl: '/courses?query=api',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'computer-security-and-networks',
      skillId: 'kubernetes',
      skillName: _t('kubernetes'),
      numberOfTaggedCourses: 8,
      skillSearchUrl: '/courses?query=kubernetes',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'computer-security-and-networks',
      skillId: 'web',
      skillName: _t('web'),
      numberOfTaggedCourses: 8,
      skillSearchUrl: '/courses?query=web',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'design-and-product',
      skillId: 'user-interface',
      skillName: _t('user interface'),
      numberOfTaggedCourses: 18,
      skillSearchUrl: '/courses?query=user%20interface',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'design-and-product',
      skillId: 'user-experience',
      skillName: _t('user experience'),
      numberOfTaggedCourses: 16,
      skillSearchUrl: '/courses?query=user%20experience',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'design-and-product',
      skillId: 'software-testing',
      skillName: _t('software testing'),
      numberOfTaggedCourses: 13,
      skillSearchUrl: '/courses?query=software%20testing',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'design-and-product',
      skillId: 'game-design',
      skillName: _t('game design'),
      numberOfTaggedCourses: 11,
      skillSearchUrl: '/courses?query=game%20design',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'design-and-product',
      skillId: 'agile-software-development',
      skillName: _t('agile software development'),
      numberOfTaggedCourses: 10,
      skillSearchUrl: '/courses?query=agile%20development',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'design-and-product',
      skillId: 'graphics',
      skillName: _t('graphics'),
      numberOfTaggedCourses: 10,
      skillSearchUrl: '/courses?query=graphics',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'design-and-product',
      skillId: 'virtual-reality',
      skillName: _t('virtual reality'),
      numberOfTaggedCourses: 9,
      skillSearchUrl: '/courses?query=virtual%20reality',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'design-and-product',
      skillId: 'design-thinking',
      skillName: _t('design thinking'),
      numberOfTaggedCourses: 8,
      skillSearchUrl: '/courses?query=design%20thinking',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'design-and-product',
      skillId: 'web',
      skillName: _t('web'),
      numberOfTaggedCourses: 8,
      skillSearchUrl: '/courses?query=web',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'design-and-product',
      skillId: 'video-game-development',
      skillName: _t('video game development'),
      numberOfTaggedCourses: 7,
      skillSearchUrl: '/courses?query=video%20game',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'design-and-product',
      skillId: 'web-design',
      skillName: _t('web design'),
      numberOfTaggedCourses: 7,
      skillSearchUrl: '/courses?query=web%20design',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'design-and-product',
      skillId: 'adobe-photoshop',
      skillName: _t('adobe photoshop'),
      numberOfTaggedCourses: 6,
      skillSearchUrl: '/courses?query=photoshop',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'mobile-and-web-development',
      skillId: 'web',
      skillName: _t('web'),
      numberOfTaggedCourses: 13,
      skillSearchUrl: '/courses?query=web',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'mobile-and-web-development',
      skillId: 'mobile-app',
      skillName: _t('mobile app'),
      numberOfTaggedCourses: 9,
      skillSearchUrl: '/courses?query=mobile%20app',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'mobile-and-web-development',
      skillId: 'javascript',
      skillName: _t('javascript'),
      numberOfTaggedCourses: 8,
      skillSearchUrl: '/courses?query=javascript',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'mobile-and-web-development',
      skillId: 'mobile-application-development',
      skillName: _t('mobile application development'),
      numberOfTaggedCourses: 8,
      skillSearchUrl: '/courses?query=mobile%20application%20development',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'mobile-and-web-development',
      skillId: 'web-development',
      skillName: _t('web development'),
      numberOfTaggedCourses: 8,
      skillSearchUrl: '/courses?query=web%20development',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'mobile-and-web-development',
      skillId: 'android-software-development',
      skillName: _t('android software development'),
      numberOfTaggedCourses: 7,
      skillSearchUrl: '/courses?query=android%20software%20development',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'mobile-and-web-development',
      skillId: 'cascading-style-sheets',
      skillName: _t('CSS'),
      numberOfTaggedCourses: 6,
      skillSearchUrl: '/courses?query=CSS',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'mobile-and-web-development',
      skillId: 'programming-language',
      skillName: _t('programming language'),
      numberOfTaggedCourses: 6,
      skillSearchUrl: '/courses?query=programming%20languages',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'mobile-and-web-development',
      skillId: 'web-application',
      skillName: _t('web application'),
      numberOfTaggedCourses: 6,
      skillSearchUrl: '/courses?query=web%20application',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'mobile-and-web-development',
      skillId: 'android-studio',
      skillName: _t('android studio'),
      numberOfTaggedCourses: 5,
      skillSearchUrl: '/courses?query=android%20studio',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'mobile-and-web-development',
      skillId: 'angularjs',
      skillName: _t('angularjs'),
      numberOfTaggedCourses: 5,
      skillSearchUrl: '/courses?query=angularjs',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'mobile-and-web-development',
      skillId: 'computer-program',
      skillName: _t('computer program'),
      numberOfTaggedCourses: 5,
      skillSearchUrl: '/courses?query=computer%20programs',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'software-development',
      skillId: 'programming-language',
      skillName: _t('programming language'),
      numberOfTaggedCourses: 34,
      skillSearchUrl: '/courses?query=programming%20languages',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'software-development',
      skillId: 'google',
      skillName: _t('google'),
      numberOfTaggedCourses: 25,
      skillSearchUrl: '/courses?query=google',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'software-development',
      skillId: 'computer-program',
      skillName: _t('computer program'),
      numberOfTaggedCourses: 21,
      skillSearchUrl: '/courses?query=computer%20programs',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'software-development',
      skillId: 'software-testing',
      skillName: _t('software testing'),
      numberOfTaggedCourses: 21,
      skillSearchUrl: '/courses?query=software%20testing',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'software-development',
      skillId: 'web',
      skillName: _t('web'),
      numberOfTaggedCourses: 19,
      skillSearchUrl: '/courses?query=web',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'software-development',
      skillId: 'google-cloud-platform',
      skillName: _t('google cloud platform'),
      numberOfTaggedCourses: 18,
      skillSearchUrl: '/courses?query=google%20cloud%20platform',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'software-development',
      skillId: 'application-programming-interfaces',
      skillName: _t('application programming interfaces'),
      numberOfTaggedCourses: 17,
      skillSearchUrl: '/courses?query=api',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'software-development',
      skillId: 'data-structure',
      skillName: _t('data structure'),
      numberOfTaggedCourses: 16,
      skillSearchUrl: '/courses?query=data%20structure',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'software-development',
      skillId: 'problem-solving',
      skillName: _t('problem solving'),
      numberOfTaggedCourses: 14,
      skillSearchUrl: '/courses?query=problem%20solving',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'software-development',
      skillId: 'object-oriented-programming',
      skillName: _t('object-oriented programming'),
      numberOfTaggedCourses: 13,
      skillSearchUrl: '/courses?query=object%20oriented%20design',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'software-development',
      skillId: 'kubernetes',
      skillName: _t('kubernetes'),
      numberOfTaggedCourses: 10,
      skillSearchUrl: '/courses?query=kubernetes',
    },
    {
      domainId: 'computer-science',
      subDomainId: 'software-development',
      skillId: 'list-and-label',
      skillName: _t('list & label'),
      numberOfTaggedCourses: 10,
      skillSearchUrl: '/courses?query=list%20%26%20label',
    },
    {
      domainId: 'data-science',
      subDomainId: 'data-analysis',
      skillId: 'analytics',
      skillName: _t('analytics'),
      numberOfTaggedCourses: 85,
      skillSearchUrl: '/courses?query=analytics',
    },
    {
      domainId: 'data-science',
      subDomainId: 'data-analysis',
      skillId: 'big-data',
      skillName: _t('big data'),
      numberOfTaggedCourses: 64,
      skillSearchUrl: '/courses?query=big%20data',
    },
    {
      domainId: 'data-science',
      subDomainId: 'data-analysis',
      skillId: 'python-programming-language',
      skillName: _t('python programming'),
      numberOfTaggedCourses: 47,
      skillSearchUrl: '/courses?query=python%20programming',
    },
    {
      domainId: 'data-science',
      subDomainId: 'data-analysis',
      skillId: 'business-analytics',
      skillName: _t('business analytics'),
      numberOfTaggedCourses: 40,
      skillSearchUrl: '/courses?query=business%20analytics',
    },
    {
      domainId: 'data-science',
      subDomainId: 'data-analysis',
      skillId: 'r-programming-language',
      skillName: _t('r programming'),
      numberOfTaggedCourses: 37,
      skillSearchUrl: '/courses?query=r%20programming',
    },
    {
      domainId: 'data-science',
      subDomainId: 'data-analysis',
      skillId: 'statistical-analysis',
      skillName: _t('statistical analysis'),
      numberOfTaggedCourses: 36,
      skillSearchUrl: '/courses?query=statistical%20analysis',
    },
    {
      domainId: 'data-science',
      subDomainId: 'data-analysis',
      skillId: 'sql',
      skillName: _t('sql'),
      numberOfTaggedCourses: 33,
      skillSearchUrl: '/courses?query=sql',
    },
    {
      domainId: 'data-science',
      subDomainId: 'data-analysis',
      skillId: 'data-model',
      skillName: _t('data model'),
      numberOfTaggedCourses: 29,
      skillSearchUrl: '/courses?query=data%20modeling',
    },
    {
      domainId: 'data-science',
      subDomainId: 'data-analysis',
      skillId: 'data-mining',
      skillName: _t('data mining'),
      numberOfTaggedCourses: 27,
      skillSearchUrl: '/courses?query=data%20mining',
    },
    {
      domainId: 'data-science',
      subDomainId: 'data-analysis',
      skillId: 'exploratory-data-analysis',
      skillName: _t('exploratory data analysis'),
      numberOfTaggedCourses: 26,
      skillSearchUrl: '/courses?query=exploratory%20data%20analysis',
    },
    {
      domainId: 'data-science',
      subDomainId: 'data-analysis',
      skillId: 'data-modeling',
      skillName: _t('data modeling'),
      numberOfTaggedCourses: 21,
      skillSearchUrl: '/courses?query=data%20modeling',
    },
    {
      domainId: 'data-science',
      subDomainId: 'data-analysis',
      skillId: 'data-manipulation',
      skillName: _t('data manipulation'),
      numberOfTaggedCourses: 20,
      skillSearchUrl: '/courses?query=data%20manipulation',
    },
    {
      domainId: 'data-science',
      subDomainId: 'machine-learning',
      skillId: 'python-programming-language',
      skillName: _t('python programming'),
      numberOfTaggedCourses: 33,
      skillSearchUrl: '/courses?query=python%20programming',
    },
    {
      domainId: 'data-science',
      subDomainId: 'machine-learning',
      skillId: 'tensorflow',
      skillName: _t('tensorflow'),
      numberOfTaggedCourses: 32,
      skillSearchUrl: '/courses?query=tensorflow',
    },
    {
      domainId: 'data-science',
      subDomainId: 'machine-learning',
      skillId: 'deep-learning',
      skillName: _t('deep learning'),
      numberOfTaggedCourses: 30,
      skillSearchUrl: '/courses?query=deep%20learning',
    },
    {
      domainId: 'data-science',
      subDomainId: 'machine-learning',
      skillId: 'artificial-neural-network',
      skillName: _t('artificial neural network'),
      numberOfTaggedCourses: 24,
      skillSearchUrl: '/courses?query=artificial%20neural%20network',
    },
    {
      domainId: 'data-science',
      subDomainId: 'machine-learning',
      skillId: 'big-data',
      skillName: _t('big data'),
      numberOfTaggedCourses: 18,
      skillSearchUrl: '/courses?query=big%20data',
    },
    {
      domainId: 'data-science',
      subDomainId: 'machine-learning',
      skillId: 'statistical-classification',
      skillName: _t('statistical classification'),
      numberOfTaggedCourses: 17,
      skillSearchUrl: '/courses?query=statistical%20classification',
    },
    {
      domainId: 'data-science',
      subDomainId: 'machine-learning',
      skillId: 'reinforcement-learning',
      skillName: _t('reinforcement learning'),
      numberOfTaggedCourses: 13,
      skillSearchUrl: '/courses?query=reinforcement%20learning',
    },
    {
      domainId: 'data-science',
      subDomainId: 'machine-learning',
      skillId: 'algebra',
      skillName: _t('algebra'),
      numberOfTaggedCourses: 10,
      skillSearchUrl: '/courses?query=algebra',
    },
    {
      domainId: 'data-science',
      subDomainId: 'machine-learning',
      skillId: 'bayesian',
      skillName: _t('bayesian'),
      numberOfTaggedCourses: 10,
      skillSearchUrl: '/courses?query=bayesian',
    },
    {
      domainId: 'data-science',
      subDomainId: 'machine-learning',
      skillId: 'linear-algebra',
      skillName: _t('linear algebra'),
      numberOfTaggedCourses: 10,
      skillSearchUrl: '/courses?query=linear%20algebra',
    },
    {
      domainId: 'data-science',
      subDomainId: 'machine-learning',
      skillId: 'linear-regression',
      skillName: _t('linear regression'),
      numberOfTaggedCourses: 9,
      skillSearchUrl: '/courses?query=linear%20regression',
    },
    {
      domainId: 'data-science',
      subDomainId: 'machine-learning',
      skillId: 'numpy',
      skillName: _t('numpy'),
      numberOfTaggedCourses: 9,
      skillSearchUrl: '/courses?query=numpy',
    },
    {
      domainId: 'data-science',
      subDomainId: 'probability-and-statistics',
      skillId: 'r-programming-language',
      skillName: _t('r programming'),
      numberOfTaggedCourses: 19,
      skillSearchUrl: '/courses?query=r%20programming',
    },
    {
      domainId: 'data-science',
      subDomainId: 'probability-and-statistics',
      skillId: 'inference',
      skillName: _t('inference'),
      numberOfTaggedCourses: 16,
      skillSearchUrl: '/courses?query=statistical%20inference',
    },
    {
      domainId: 'data-science',
      subDomainId: 'probability-and-statistics',
      skillId: 'linear-regression',
      skillName: _t('linear regression'),
      numberOfTaggedCourses: 12,
      skillSearchUrl: '/courses?query=linear%20regression',
    },
    {
      domainId: 'data-science',
      subDomainId: 'probability-and-statistics',
      skillId: 'statistical-analysis',
      skillName: _t('statistical analysis'),
      numberOfTaggedCourses: 12,
      skillSearchUrl: '/courses?query=statistical%20analysis',
    },
    {
      domainId: 'data-science',
      subDomainId: 'probability-and-statistics',
      skillId: 'statistical-inference',
      skillName: _t('statistical inference'),
      numberOfTaggedCourses: 11,
      skillSearchUrl: '/courses?query=statistical%20inference',
    },
    {
      domainId: 'data-science',
      subDomainId: 'probability-and-statistics',
      skillId: 'regression-analysis',
      skillName: _t('regression analysis'),
      numberOfTaggedCourses: 10,
      skillSearchUrl: '/courses?query=regression%20analysis',
    },
    {
      domainId: 'data-science',
      subDomainId: 'probability-and-statistics',
      skillId: 'biostatistics',
      skillName: _t('biostatistics'),
      numberOfTaggedCourses: 9,
      skillSearchUrl: '/courses?query=biostatistics',
    },
    {
      domainId: 'data-science',
      subDomainId: 'probability-and-statistics',
      skillId: 'bayesian',
      skillName: _t('bayesian'),
      numberOfTaggedCourses: 7,
      skillSearchUrl: '/courses?query=bayesian',
    },
    {
      domainId: 'data-science',
      subDomainId: 'probability-and-statistics',
      skillId: 'logistic-regression',
      skillName: _t('logistic regression'),
      numberOfTaggedCourses: 7,
      skillSearchUrl: '/courses?query=logistic%20regression',
    },
    {
      domainId: 'data-science',
      subDomainId: 'probability-and-statistics',
      skillId: 'probability-distribution',
      skillName: _t('probability distribution'),
      numberOfTaggedCourses: 7,
      skillSearchUrl: '/courses?query=probability%20distribution',
    },
    {
      domainId: 'data-science',
      subDomainId: 'probability-and-statistics',
      skillId: 'bayesian-statistics',
      skillName: _t('bayesian statistics'),
      numberOfTaggedCourses: 6,
      skillSearchUrl: '/courses?query=bayesian%20statistics',
    },
    {
      domainId: 'data-science',
      subDomainId: 'probability-and-statistics',
      skillId: 'medical-statistics',
      skillName: _t('medical statistics'),
      numberOfTaggedCourses: 6,
      skillSearchUrl: '/courses?query=medical%20statistics',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'cloud-computing',
      skillId: 'google',
      skillName: _t('google'),
      numberOfTaggedCourses: 31,
      skillSearchUrl: '/courses?query=google',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'cloud-computing',
      skillId: 'google-cloud-platform',
      skillName: _t('google cloud platform'),
      numberOfTaggedCourses: 30,
      skillSearchUrl: '/courses?query=google%20cloud%20platform',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'cloud-computing',
      skillId: 'kubernetes',
      skillName: _t('kubernetes'),
      numberOfTaggedCourses: 12,
      skillSearchUrl: '/courses?query=kubernetes',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'cloud-computing',
      skillId: 'application-programming-interfaces',
      skillName: _t('application programming interfaces'),
      numberOfTaggedCourses: 10,
      skillSearchUrl: '/courses?query=api',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'cloud-computing',
      skillId: 'microservices',
      skillName: _t('microservices'),
      numberOfTaggedCourses: 7,
      skillSearchUrl: '/courses?query=microservices',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'cloud-computing',
      skillId: 'internet-of-things',
      skillName: _t('internet of things'),
      numberOfTaggedCourses: 6,
      skillSearchUrl: '/courses?query=internet%20of%20things',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'cloud-computing',
      skillId: 'cloud-computing-security',
      skillName: _t('cloud computing security'),
      numberOfTaggedCourses: 5,
      skillSearchUrl: '/courses?query=cloud%20computing%20security',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'cloud-computing',
      skillId: 'linux',
      skillName: _t('linux'),
      numberOfTaggedCourses: 4,
      skillSearchUrl: '/courses?query=linux',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'cloud-computing',
      skillId: 'statistical-classification',
      skillName: _t('statistical classification'),
      numberOfTaggedCourses: 4,
      skillSearchUrl: '/courses?query=statistical%20classification',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'cloud-computing',
      skillId: 'web',
      skillName: _t('web'),
      numberOfTaggedCourses: 4,
      skillSearchUrl: '/courses?query=web',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'cloud-computing',
      skillId: 'computer-security',
      skillName: _t('cybersecurity'),
      numberOfTaggedCourses: 3,
      skillSearchUrl: '/courses?query=cybersecurity',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'cloud-computing',
      skillId: 'cryptography',
      skillName: _t('cryptography'),
      numberOfTaggedCourses: 3,
      skillSearchUrl: '/courses?query=cryptography',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'data-management',
      skillId: 'google',
      skillName: _t('google'),
      numberOfTaggedCourses: 4,
      skillSearchUrl: '/courses?query=google',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'data-management',
      skillId: 'google-cloud-platform',
      skillName: _t('google cloud platform'),
      numberOfTaggedCourses: 4,
      skillSearchUrl: '/courses?query=google%20cloud%20platform',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'data-management',
      skillId: 'application-programming-interfaces',
      skillName: _t('application programming interfaces'),
      numberOfTaggedCourses: 2,
      skillSearchUrl: '/courses?query=api',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'data-management',
      skillId: 'mongodb',
      skillName: _t('mongodb'),
      numberOfTaggedCourses: 2,
      skillSearchUrl: '/courses?query=mongodb',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'data-management',
      skillId: 'apache-hadoop',
      skillName: _t('apache hadoop'),
      numberOfTaggedCourses: 1,
      skillSearchUrl: '/courses?query=apache%20hadoop',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'data-management',
      skillId: 'applied-machine-learning',
      skillName: _t('applied machine learning'),
      numberOfTaggedCourses: 1,
      skillSearchUrl: '/courses?query=applied%20machine%20learning',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'data-management',
      skillId: 'arrays',
      skillName: _t('arrays'),
      numberOfTaggedCourses: 1,
      skillSearchUrl: '/courses?query=arrays',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'data-management',
      skillId: 'cascading-style-sheets',
      skillName: _t('CSS'),
      numberOfTaggedCourses: 1,
      skillSearchUrl: '/courses?query=CSS',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'data-management',
      skillId: 'cluster-analysis',
      skillName: _t('cluster analysis'),
      numberOfTaggedCourses: 1,
      skillSearchUrl: '/courses?query=cluster%20analysis',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'data-management',
      skillId: 'data-structure',
      skillName: _t('data structure'),
      numberOfTaggedCourses: 1,
      skillSearchUrl: '/courses?query=data%20structure',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'data-management',
      skillId: 'e-commerce',
      skillName: _t('e-commerce'),
      numberOfTaggedCourses: 1,
      skillSearchUrl: '/courses?query=e-commerce',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'data-management',
      skillId: 'graphics',
      skillName: _t('graphics'),
      numberOfTaggedCourses: 1,
      skillSearchUrl: '/courses?query=graphics',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'networking',
      skillId: 'internet',
      skillName: _t('internet'),
      numberOfTaggedCourses: 7,
      skillSearchUrl: '/courses?query=internet',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'networking',
      skillId: 'cisco',
      skillName: _t('Cisco'),
      numberOfTaggedCourses: 5,
      skillSearchUrl: '/courses?query=Cisco',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'networking',
      skillId: 'internet-protocol-suite',
      skillName: _t('internet protocol suite'),
      numberOfTaggedCourses: 5,
      skillSearchUrl: '/courses?query=internet%20protocol%20suite',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'networking',
      skillId: 'google',
      skillName: _t('google'),
      numberOfTaggedCourses: 4,
      skillSearchUrl: '/courses?query=google',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'networking',
      skillId: 'network-analysis',
      skillName: _t('network analysis'),
      numberOfTaggedCourses: 3,
      skillSearchUrl: '/courses?query=network%20analysis',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'networking',
      skillId: 'network-security',
      skillName: _t('network security'),
      numberOfTaggedCourses: 3,
      skillSearchUrl: '/courses?query=network%20security',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'networking',
      skillId: 'wireless',
      skillName: _t('wireless'),
      numberOfTaggedCourses: 3,
      skillSearchUrl: '/courses?query=wireless',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'networking',
      skillId: 'google-cloud-platform',
      skillName: _t('google cloud platform'),
      numberOfTaggedCourses: 2,
      skillSearchUrl: '/courses?query=google%20cloud%20platform',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'networking',
      skillId: 'internet-of-things',
      skillName: _t('internet of things'),
      numberOfTaggedCourses: 2,
      skillSearchUrl: '/courses?query=internet%20of%20things',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'networking',
      skillId: 'software-testing',
      skillName: _t('software testing'),
      numberOfTaggedCourses: 2,
      skillSearchUrl: '/courses?query=software%20testing',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'networking',
      skillId: 'cloud-computing-security',
      skillName: _t('cloud computing security'),
      numberOfTaggedCourses: 1,
      skillSearchUrl: '/courses?query=cloud%20computing%20security',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'networking',
      skillId: 'computer-security',
      skillName: _t('cybersecurity'),
      numberOfTaggedCourses: 1,
      skillSearchUrl: '/courses?query=cybersecurity',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'security',
      skillId: 'computer-security',
      skillName: _t('cybersecurity'),
      numberOfTaggedCourses: 14,
      skillSearchUrl: '/courses?query=cybersecurity',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'security',
      skillId: 'information-security',
      skillName: _t('information security'),
      numberOfTaggedCourses: 7,
      skillSearchUrl: '/courses?query=information%20security',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'security',
      skillId: 'linux',
      skillName: _t('linux'),
      numberOfTaggedCourses: 4,
      skillSearchUrl: '/courses?query=linux',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'security',
      skillId: 'network-security',
      skillName: _t('network security'),
      numberOfTaggedCourses: 4,
      skillSearchUrl: '/courses?query=network%20security',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'security',
      skillId: 'cryptography',
      skillName: _t('cryptography'),
      numberOfTaggedCourses: 3,
      skillSearchUrl: '/courses?query=cryptography',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'security',
      skillId: 'penetration-test',
      skillName: _t('penetration test'),
      numberOfTaggedCourses: 3,
      skillSearchUrl: '/courses?query=pen%20testing',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'security',
      skillId: 'privacy',
      skillName: _t('privacy'),
      numberOfTaggedCourses: 3,
      skillSearchUrl: '/courses?query=privacy',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'security',
      skillId: 'risk-assessment',
      skillName: _t('risk assessment'),
      numberOfTaggedCourses: 3,
      skillSearchUrl: '/courses?query=risk%20assessment',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'security',
      skillId: 'software-testing',
      skillName: _t('software testing'),
      numberOfTaggedCourses: 3,
      skillSearchUrl: '/courses?query=software%20testing',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'security',
      skillId: 'google',
      skillName: _t('google'),
      numberOfTaggedCourses: 2,
      skillSearchUrl: '/courses?query=google',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'security',
      skillId: 'list-and-label',
      skillName: _t('list & label'),
      numberOfTaggedCourses: 2,
      skillSearchUrl: '/courses?query=list%20%26%20label',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'security',
      skillId: 'wireless',
      skillName: _t('wireless'),
      numberOfTaggedCourses: 2,
      skillSearchUrl: '/courses?query=wireless',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'support-and-operations',
      skillId: 'google',
      skillName: _t('google'),
      numberOfTaggedCourses: 8,
      skillSearchUrl: '/courses?query=google',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'support-and-operations',
      skillId: 'linux',
      skillName: _t('linux'),
      numberOfTaggedCourses: 6,
      skillSearchUrl: '/courses?query=linux',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'support-and-operations',
      skillId: 'software-testing',
      skillName: _t('software testing'),
      numberOfTaggedCourses: 5,
      skillSearchUrl: '/courses?query=software%20testing',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'support-and-operations',
      skillId: 'internet',
      skillName: _t('internet'),
      numberOfTaggedCourses: 4,
      skillSearchUrl: '/courses?query=internet',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'support-and-operations',
      skillId: 'problem-solving',
      skillName: _t('problem solving'),
      numberOfTaggedCourses: 4,
      skillSearchUrl: '/courses?query=problem%20solving',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'support-and-operations',
      skillId: 'application-programming-interfaces',
      skillName: _t('application programming interfaces'),
      numberOfTaggedCourses: 3,
      skillSearchUrl: '/courses?query=api',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'support-and-operations',
      skillId: 'computer-security',
      skillName: _t('cybersecurity'),
      numberOfTaggedCourses: 3,
      skillSearchUrl: '/courses?query=cybersecurity',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'support-and-operations',
      skillId: 'software-project-management',
      skillName: _t('software project management'),
      numberOfTaggedCourses: 3,
      skillSearchUrl: '/courses?query=software%20project%20management',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'support-and-operations',
      skillId: 'web',
      skillName: _t('web'),
      numberOfTaggedCourses: 3,
      skillSearchUrl: '/courses?query=web',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'support-and-operations',
      skillId: 'bash-unix-shell',
      skillName: _t('bash (unix shell)'),
      numberOfTaggedCourses: 2,
      skillSearchUrl: '/courses?query=bash%20script',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'support-and-operations',
      skillId: 'computer-program',
      skillName: _t('computer program'),
      numberOfTaggedCourses: 2,
      skillSearchUrl: '/courses?query=computer%20programs',
    },
    {
      domainId: 'information-technology',
      subDomainId: 'support-and-operations',
      skillId: 'list-and-label',
      skillName: _t('list & label'),
      numberOfTaggedCourses: 2,
      skillSearchUrl: '/courses?query=list%20%26%20label',
    },
  ];
};

export default getSubDomainSkillsData;
